import { render, staticRenderFns } from "./agregarCaja.vue?vue&type=template&id=534e48a7"
import script from "./agregarCaja.vue?vue&type=script&lang=js"
export * from "./agregarCaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports